import { useState } from "react";
import {  useSearchWashingAreaRawMaterialQuery } from "../unloading/unloadingApi";
import {  useGetWashingAreaSummaryQuery } from "../../../app/globalApi";
import TotalCase from "../../../images/totalCase.svg";
import AcceptedCase from "../../../images/accepted_cases.svg";
import RejectedCase from "../../../images/rejected_case.svg";
import NotWashed from "../../../images/not_washed.svg";
import TotalOrangeCase from "../../../images/total_orange.svg";
import OrangeIncrease from "../../../images/orange_increase.svg";
import MaterialOrange from "../../../images/material_orange.svg";
import Button from "../../../components/shared/buttons/button";
import DateSelector from "../../../components/shared/fields/DateSelector";
import EditWashingModal from "./EditWashingModal";
import GridCard from "../../../components/shared/gridCard/GridCard";
import Datatable from "../../../components/shared/datatable/Datatable";
import OverviewModal from "../../../components/shared/modalContent/OverviewModal";

import useTranslator from "../../../hooks/useTranslator";
import UpdateWashingModal from "./UpdateWashingModal";
import { convertToUserTimezone, formatDateAndTime, getCurrentDate } from "../../../helpers/Utils";
import { PROJECT_DATE_FORMAT } from "../../../helpers/constants";
import "../../dashboard/components/dashboard-sections.css";



const WashingArea = () => {
  const [page, setPage] = useState(1);
  const [showOverviewModal, setShowOverviewModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [selectedRawMaterial, setSelectedRawMaterial] = useState(null);
  const [addWashing, setAddWashing] = useState(false);
  const [updateWashing, setUpdateWashing] = useState(false);
  // const today = new Date();
  const currentDate = getCurrentDate("YYYY-MM-DD");
  const [date, setDate] = useState(currentDate);
  const [tab, setTab] = useState("washing");
  const [filter, setFilter] = useState({});
  const [appliedFilters, setAppliedFilters] = useState({
    batch_code: "",
    washing_at: "",
    supplier_name: "",
  });

  const handleFilterApply = (newFilters) => {
    setAppliedFilters(newFilters);
    setFilter(newFilters);
  };
  
  const { 
          data: rawMaterial,
          isLoading,
          isFetching,
          isError,
          error,
          refetch : refetchRecord 
        } = useSearchWashingAreaRawMaterialQuery(
          {
            page, 
            ...filter
          },
          { refetchOnMountOrArgChange: true }
        );

  const { data: summaryData } = useGetWashingAreaSummaryQuery(
    { 
      tab,
      date
    },
    { refetchOnMountOrArgChange: true }
  );

  const { _t } = useTranslator();

  const listItems = [
    {
      label: _t("total_cases_entered_washing", "Total Cases Entered"),
      value: summaryData?.data.total_cases_entered,
      icon: TotalCase,
    },
    {
      label: _t("total_cases_accepted_washing", "Total Cases Accepted"),
      value: summaryData?.data.total_accepted_cases,
      icon: AcceptedCase,
    },
    {
      label: _t("rejected_cases", "Rejected Cases"),
      value: summaryData?.data.rejected_cases,
      icon: RejectedCase,
    },
    {
      label: _t("cases_not_washed_label", "Cases Not Washed"),
      value: summaryData?.data.cases_not_washed,
      icon: NotWashed,
    },
    {
      label: _t("total_orange_cases", "Total Orange Cases"),
      value: summaryData?.data.total_orange_cases,
      icon: TotalOrangeCase,
    },
    {
      label: _t("orange_case_increase", "Orange Case Increase"),
      value: summaryData?.data.orange_case_increase
        ? Number(summaryData?.data.orange_case_increase).toFixed(2) + " %"
        : "0.0 %",
      icon: OrangeIncrease,
    },
    {
      label: _t("weight_in_orange_case", "Weight In Orange Case"),
      value: summaryData?.data.weight_in_orange_cases,
      icon: MaterialOrange,
    },
  ];
  const handlePageChange = (page) => {
    setPage(page);
  };

  const handleEdit = (unloading) => {
    setAddWashing(true);
    setModalMode("edit");
    setSelectedRawMaterial(unloading);
  };

  const handleUpdate = (unloading) => {
    setUpdateWashing(true);
    setModalMode("edit");
    setSelectedRawMaterial(unloading);
  };

  const handleView = (unloading) => {
    setSelectedRawMaterial(unloading);
    setShowOverviewModal(true);
  };
  const columns = [
    {
      label: _t("washed_ready_at", "Washing Date"),
      accessor: "washed_ready_at",
      cell: ({ value }) => {
        return convertToUserTimezone(value , "YYYY-MM-DD hh:mm A");
      },
    },
    { label: _t("supplier_name", "Supplier Name"), accessor: "supplier_name" },
    { label: _t("batch_code", "Batch Code"), accessor: "batch_code" },
    { label: _t("brix", "Brix"), accessor: "brix_level" },
    { label: _t("cases_entered", "Cases Entered"), accessor: "total_cases" },
    { label: _t("pallet_count_label", "Pallet Count"), accessor: "total_pallets" },
    { label: _t("kg_before_wash", "KG Before wash"), accessor: "kg_entered" },
    {
      label: _t("kg_after_wash", "KG After wash"),
      accessor: "kg_after_wash",
      cell: ({ row }) => {
        const kgAfterWash = row.kg_after_wash;
        return kgAfterWash === null ? "No data yet" : kgAfterWash;
      },
    },
    {
      label: _t("overview", "Overview"),
      cell: ({ row }) => (
        <div style={{ display: "flex", gap: "8px" }}>
          {row.status === "washing_done" && (
            <Button
              size="small"
              label={_t("view", "View")}
              className="borderRedBtn"
              onClick={() => handleView(row)}
            />
          )}
          {row.status === "washing_ready" && (
            <Button
              size="small"
              label={_t("edit", "Edit")}
              onClick={() => handleEdit(row)}
            />
          )}
          {row.status === "washing_done" && row.is_editable == "1" && (
            <Button
              size="small"
              label={_t("edit", "Edit")}
              onClick={() => handleUpdate(row)}
            />
          )}
        </div>
      ),
    },

  ];

  return (
    <div>
      {addWashing && (
        <EditWashingModal
          show={addWashing}
          setShow={setAddWashing}
          mode={modalMode}
          unloading={selectedRawMaterial}
        />
      )}
      {updateWashing && (
        <UpdateWashingModal
          show={updateWashing}
          setShow={setUpdateWashing}
          mode={modalMode}
          unloading={selectedRawMaterial}
        />
      )}
      {showOverviewModal && (
        <OverviewModal
          show={showOverviewModal}
          setShow={setShowOverviewModal}
          unloading={selectedRawMaterial}
          mode="washing"
        />
      )}
      <div className="overview cmn_card mb-3">
        <div className="overview_header d-flex gap-2 align-items-center">
          <h6 className="mb-0 flex-grow-1">
            {_t("washing_area_overview", "Washing Area Overview")}
          </h6>
          <DateSelector setDate={setDate} />
        </div>
        <ul className="m-0 grid_card_wrapper">
          {listItems.map((list, index) => (
            <GridCard
              key={index}
              title={list.label}
              value={list.value}
              icon={list.icon}
              day={currentDate === date ? _t("today", "Today") :  formatDateAndTime(date,PROJECT_DATE_FORMAT)}
            />
          ))}
        </ul>

      </div>
      <Datatable
        title={_t("washing_area_log", "Washing Area Log")}
        columns={columns}
        tableData={rawMaterial?.data}
        pagination
        page={page}
        onPageChange={handlePageChange}
        showFilter={handleFilterApply}
        showFilterButton={true}
        filterModule="washing-area"
        filters={appliedFilters}
        isLoading={isLoading || isFetching}
      />
    </div>
  );
};

export default WashingArea;
